import { watch } from 'vue';
import en from './locale/en';
import ar from './locale/ar';

// Keep the primary support languages ready; other dictionaries are separate
// chunks rather than shipping every language on each dashboard reload.
const localeLoaders = {
  './locale/bg/index.js': () => import('./locale/bg'),
  './locale/ca/index.js': () => import('./locale/ca'),
  './locale/cs/index.js': () => import('./locale/cs'),
  './locale/da/index.js': () => import('./locale/da'),
  './locale/de/index.js': () => import('./locale/de'),
  './locale/el/index.js': () => import('./locale/el'),
  './locale/es/index.js': () => import('./locale/es'),
  './locale/et/index.js': () => import('./locale/et'),
  './locale/fa/index.js': () => import('./locale/fa'),
  './locale/fi/index.js': () => import('./locale/fi'),
  './locale/fr/index.js': () => import('./locale/fr'),
  './locale/he/index.js': () => import('./locale/he'),
  './locale/hi/index.js': () => import('./locale/hi'),
  './locale/hu/index.js': () => import('./locale/hu'),
  './locale/id/index.js': () => import('./locale/id'),
  './locale/it/index.js': () => import('./locale/it'),
  './locale/ja/index.js': () => import('./locale/ja'),
  './locale/ko/index.js': () => import('./locale/ko'),
  './locale/lv/index.js': () => import('./locale/lv'),
  './locale/ml/index.js': () => import('./locale/ml'),
  './locale/nl/index.js': () => import('./locale/nl'),
  './locale/no/index.js': () => import('./locale/no'),
  './locale/pl/index.js': () => import('./locale/pl'),
  './locale/pt/index.js': () => import('./locale/pt'),
  './locale/pt_BR/index.js': () => import('./locale/pt_BR'),
  './locale/ro/index.js': () => import('./locale/ro'),
  './locale/ru/index.js': () => import('./locale/ru'),
  './locale/sk/index.js': () => import('./locale/sk'),
  './locale/sl/index.js': () => import('./locale/sl'),
  './locale/sr/index.js': () => import('./locale/sr'),
  './locale/sv/index.js': () => import('./locale/sv'),
  './locale/ta/index.js': () => import('./locale/ta'),
  './locale/th/index.js': () => import('./locale/th'),
  './locale/tr/index.js': () => import('./locale/tr'),
  './locale/uk/index.js': () => import('./locale/uk'),
  './locale/uz/index.js': () => import('./locale/uz'),
  './locale/vi/index.js': () => import('./locale/vi'),
  './locale/zh_CN/index.js': () => import('./locale/zh_CN'),
  './locale/zh_TW/index.js': () => import('./locale/zh_TW'),
  './locale/is/index.js': () => import('./locale/is'),
  './locale/lt/index.js': () => import('./locale/lt'),
};

export function installLocaleLoader(i18n, loaders = localeLoaders) {
  const loaded = new Set(['en', 'ar']);
  const pending = new Map();
  return watch(
    i18n.global.locale,
    async locale => {
      const loader = loaders[`./locale/${locale}/index.js`];
      if (loaded.has(locale) || !loader) return;
      try {
        if (!pending.has(locale)) pending.set(locale, loader());
        const module = await pending.get(locale);
        i18n.global.setLocaleMessage(locale, module.default);
        loaded.add(locale);
      } catch {
        // English fallback stays usable; allow retry after a later switch.
      } finally {
        pending.delete(locale);
      }
    },
    { immediate: true }
  );
}

export default { en, ar };
